var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.205078,
  y: 0.390625,
  width: 24,
  height: 24,
  rx: 8,
  fill: "#F1F9FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4151_39361)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2051 7.01562C12.3478 7.01562 12.4782 7.09665 12.5414 7.22464L13.9992 10.178L17.2593 10.6546C17.4005 10.6752 17.5178 10.7742 17.5618 10.91C17.6058 11.0457 17.569 11.1947 17.4667 11.2943L15.108 13.5916L15.6647 16.8372C15.6888 16.9779 15.631 17.1201 15.5155 17.204C15.4 17.2879 15.2469 17.299 15.1205 17.2325L12.2051 15.6993L9.28963 17.2325C9.16329 17.299 9.01018 17.2879 8.89469 17.204C8.7792 17.1201 8.72136 16.9779 8.74549 16.8372L9.30214 13.5916L6.94344 11.2943C6.84121 11.1947 6.80436 11.0457 6.84837 10.91C6.89239 10.7742 7.00964 10.6752 7.15085 10.6546L10.411 10.178L11.8688 7.22464C11.932 7.09665 12.0624 7.01562 12.2051 7.01562ZM12.2051 8.23784L10.9964 10.6866C10.9418 10.7972 10.8363 10.8738 10.7143 10.8917L8.01074 11.2869L9.96674 13.192C10.0552 13.2781 10.0956 13.4023 10.0747 13.524L9.61316 16.215L12.0305 14.9437C12.1398 14.8863 12.2704 14.8863 12.3796 14.9437L14.797 16.215L14.3355 13.524C14.3146 13.4023 14.355 13.2781 14.4434 13.192L16.3994 11.2869L13.6959 10.8917C13.5738 10.8738 13.4684 10.7972 13.4138 10.6866L12.2051 8.23784Z",
  fill: "#00538F"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4151_39361"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(6.20508 6.39062)"
})));

function SvgOrderStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderStar);
export default __webpack_public_path__ + "static/media/order-star.fbb8d2bb.svg";
export { ForwardRef as ReactComponent };